import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

const group = (n) => new Intl.NumberFormat("id-ID").format(n);

// Input uang dengan pemisah ribuan (format id-ID: 1.000.000).
// value: number | "" ; onValueChange dipanggil dengan number | "".
const MoneyInput = forwardRef(function MoneyInput({ value, onValueChange, ...props }, ref) {
  const display =
    value === "" || value === null || value === undefined || isNaN(Number(value))
      ? ""
      : group(Number(value));

  const handle = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "");
    if (digits === "") { onValueChange(""); return; }
    onValueChange(parseInt(digits, 10));
  };

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      value={display}
      onChange={handle}
      {...props}
    />
  );
});

export default MoneyInput;
